import React, { type FC, type PropsWithChildren } from 'react'

const SectionContext = React.createContext<{ isLocked: boolean }>({ isLocked: false })

export const SectionContextProvider: FC<PropsWithChildren<{ isLocked?: boolean }>> = ({
  isLocked = false,
  children,
}) => {
  return <SectionContext.Provider value={{ isLocked }}>{children}</SectionContext.Provider>
}

export const useSectionContext = () => {
  return React.useContext(SectionContext)
}
